/** Separator for select-option lists in the admin config grid (must not appear in labels). */
export const CONFIG_SELECT_OPTION_LIST_SEPARATOR = ' | '

/**
 * @param {Array<{ label?: string } | string> | null | undefined} options
 * @returns {string}
 */
export function formatConfigSelectOptionList(options) {
  if (!Array.isArray(options) || options.length === 0) return ''
  return options
    .map((item) => {
      if (item && typeof item === 'object') {
        return String(item.label ?? item.displayLabel ?? '').trim()
      }
      return String(item ?? '').trim()
    })
    .filter(Boolean)
    .join(CONFIG_SELECT_OPTION_LIST_SEPARATOR)
}

/**
 * @param {unknown} value
 * @returns {Array<{ label: string, value?: unknown }>}
 */
export function parseConfigSelectOptionList(value) {
  if (Array.isArray(value)) {
    return value
      .map((item) => {
        if (item && typeof item === 'object') {
          const label = String(item.label ?? item.displayLabel ?? item.value ?? '').trim()
          return label ? { label, value: item.value } : null
        }
        const label = String(item ?? '').trim()
        return label ? { label } : null
      })
      .filter(Boolean)
  }

  return String(value ?? '')
    .split(CONFIG_SELECT_OPTION_LIST_SEPARATOR)
    .map((part) => part.trim())
    .filter(Boolean)
    .map((label) => ({ label }))
}
